import React, { useMemo } from 'react';
import { FiArrowRight } from 'react-icons/fi';

import moment from 'moment';

import { bgImage, bgLogo } from 'components/AutoDetails/util';
import AutoInfo, { AutoInfoData } from 'components/AutoInfo';
import withGrid from 'hocs/withGrid';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { VehicleOption } from 'models/auto/vehicle';
import { getFormattedPrice } from 'utils/currency';

import { Card, Content, Price, Title, StyledButton as Button, Invalid, Valid, Subtitle } from './styles';

export interface Props {
  data: VehicleOption;
  onClick?: (id?: string) => void;
  testId?: string;
}

const CardAuto = ({ data, onClick, testId }: Props) => {
  const { t } = useStoreTranslation();
  const currencyCode = data.rates && data.rates?.length > 0 ? data.rates[0].pricePayNow?.currencyCode : '';
  const formattedPrice = (value: number) => {
    const { formatted } = getFormattedPrice({ value, currency: currencyCode, t });
    return formatted;
  };

  const info = {
    passengers: `${data.vehicle?.maxPax}`,
    luggage: `${data.vehicle?.normalLuggage}`,
    doors: `${data.vehicle?.doors}`,
    airConditioned: data.vehicle?.airConditioned,
    transmission: `${data.vehicle?.transmissionType}`,
    unlimitedMileage: data.rates && data.rates[0] && data.rates[0].unlimitedMileage,
  } as AutoInfoData;
  const days = useMemo(() => moment(data.dropOff?.time).diff(moment(data.pickUp?.time), 'days'), [data]);
  const price = useMemo(() => (data.rates && data.rates?.length > 0 ? data.rates[0].pricePayNow?.total : 0), [
    data.rates,
  ]);
  const priceInfo = useMemo(
    () => (days > 1 ? t('autosList.priceInfo', { quantity: days }) : t('autosList.priceInfoOneDay')),
    [days, t],
  );

  const handleOnClick = () => {
    if (onClick) onClick(data.optionId);
  };

  const _bgImage = useMemo(() => (data.vehicle?.image ? bgImage(data.vehicle.image) : {}), [data]);
  const _bgLogo = useMemo(() => (data.company?.code ? bgLogo(data.company.code) : {}), [data]);

  return (
    <Card onClick={handleOnClick}>
      <Card.Image>
        <Card.Logo style={_bgLogo}></Card.Logo>
        <Card.Photo style={_bgImage}></Card.Photo>
      </Card.Image>
      <Content>
        <Title>{data.vehicle?.model}</Title>
        <Subtitle>{data.vehicle?.vehicleCategory}</Subtitle>
        <Card.AutoInfo>
          <AutoInfo data={info} showAirConditioned={false} mini={true}></AutoInfo>
        </Card.AutoInfo>
        <Price>
          <Price.Total>{typeof price === 'number' ? formattedPrice(price) : ''}</Price.Total>
          <Price.Info>{priceInfo}</Price.Info>
          <Price.Policy>
            {!data.isPreApproved && data.breakRulesMessage && data.breakRulesMessage.length > 0 ? (
              <Invalid>{t('hotelFlightsTags.invalid')}</Invalid>
            ) : (
              <Valid>{t('hotelFlightsTags.valid')}</Valid>
            )}
          </Price.Policy>
        </Price>
        <Button>
          <FiArrowRight />
        </Button>
      </Content>
    </Card>
  );
};

export default withGrid(CardAuto);
